import { AttendeeSessionProvider, useAttendeeSessions } from './AttendeeSessionContext';
import { PLACEHOLDER_ACTIVE_SESSION } from '../../mockSessionsData';

export { AttendeeSessionProvider, useAttendeeSessions, PLACEHOLDER_ACTIVE_SESSION };
